import { Box, Stack } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { ErpPrice } from "@tm/models"
import { Typography } from "../../../muiStyled/DataDisplay/typographie"

type Props = {
    price: ErpPrice
    showTaxIncluded: boolean
    isStrikeThrough?: boolean
}

export function TooltipPrice({ price, showTaxIncluded, isStrikeThrough }: Props) {
    const { currency, translateText } = useLocalization()

    return (
        <Stack spacing={0.5}>
            {!!price.description && (
                <Typography
                    variant="label"
                    color="#FFFFFF"
                    sx={{ textDecoration: isStrikeThrough ? "line-through" : "none", opacity: 1 }}
                >{`${price.description}: ${currency(price.value, price.currencySymbol || "")}`}</Typography>
            )}
            {!price.taxIncluded && price.valueTaxIncluded && showTaxIncluded && (
                <Box>
                    {translateText(12851)}:&nbsp;
                    {currency(price.valueTaxIncluded, price.currencySymbol || "")}
                </Box>
            )}
            {!!price.rebatePercent && (
                <Box>
                    {translateText(54)}:&nbsp;
                    {price.rebatePercent.round(0.01)}%
                </Box>
            )}
        </Stack>
    )
}
